import React, { Fragment } from 'react';
import styled from 'styled-components';

import {
  Box,
  Grid,
  ListItem,
  ListItemText,
  ListSubheader,
  Tooltip,
  Typography
} from '@material-ui/core';
import { ArrowForward, InfoOutlined } from '@material-ui/icons';

import TaskStatusLabel from '../../../common/TaskStatusLabel';
import { Task, TaskBulkEvent, TaskBulkEventGroup } from '../Task.interface';
import { parseTaskStatus } from '../task.helper';

const StyledListSubheader = styled(ListSubheader)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export interface TaskBulkTransitionListItemsProps {
  bulkEventGroups: TaskBulkEventGroup[];
  onSelect?: (bulkEvent: TaskBulkEvent) => void;
}

const TaskBulkTransitionListItems: React.FC<
  TaskBulkTransitionListItemsProps
> = ({ bulkEventGroups, onSelect }) => {
  return (
    <>
      {bulkEventGroups.map((group, groupIndex) => (
        <Fragment key={groupIndex}>
          <StyledListSubheader>
            <Typography variant='overline' className='overline'>
              {bulkEventGroups.length > 1 && group.prefix
                ? group.prefix
                : 'Bulk'}{' '}
              Actions
            </Typography>
            <Tooltip
              arrow
              placement='top'
              title={<Box maxWidth={150}>{group.ids.join(', ')}</Box>}
            >
              <InfoOutlined fontSize='small' />
            </Tooltip>
          </StyledListSubheader>
          {group.bulkEvents.map((bulkEvent, bulkEventIndex) => {
            const transition = bulkEvent.event.transitions[0];
            const targetStatus = transition
              ? parseTaskStatus(transition.target)
              : undefined;
            const task: Pick<Task, 'status' | 'workflowId' | 'taskTypeName'> = {
              status: bulkEvent.stateNode.path,
              taskTypeName: group.taskType.name
            };
            return (
              <ListItem
                dense
                button
                key={`${bulkEvent.event.name}-${bulkEventIndex}`}
                onClick={() => onSelect?.(bulkEvent)}
              >
                <ListItemText
                  primary={
                    <Grid container>
                      <Grid item style={{ flex: 1 }}>
                        <Box
                          mr={1.5}
                          height='100%'
                          display='flex'
                          alignItems='center'
                          whiteSpace='nowrap'
                          gridColumnGap={2}
                        >
                          <TaskStatusLabel task={task} />
                          <ArrowForward color='action' fontSize='small' />
                          <TaskStatusLabel task={task} status={targetStatus} />
                        </Box>
                      </Grid>
                      <Grid item>
                        <Box height='100%' display='flex' alignItems='center'>
                          ({bulkEvent.taskEntities.length})
                        </Box>
                      </Grid>
                    </Grid>
                  }
                />
              </ListItem>
            );
          })}
        </Fragment>
      ))}
    </>
  );
};

export default TaskBulkTransitionListItems;
